import * as React from 'react';

import { IModalProps as IProps } from './interfaces';

export class Modal extends React.Component<IProps> {
  public render() {
    const {
      config: { component: ModalComponent },
      state: { data },
    } = this.props;

    return <ModalComponent handleClose={this.handleClose} data={data} />;
  }

  private readonly handleClose = () => {
    const { config, handleClose } = this.props;

    handleClose(config.name);
  };
}
